<svg width="75%" height="50%">
<text x="50%" y="60%"  text-anchor="middle"  style="word-wrap: break-word">
 {{text}}
</text>
</svg>